<template>
  <div id="bazzer">
    <div class="mainFixed m_b_10 m_t_10" style="position:relative;top:0;width:calc(100% - 20px);">
      <div class="allSearch d_flex">
        <dl></dl>
        <dl>
          <dt>
            <button class="redButton m_l_10"
                    @click="regimentation"><i class="icon iconfont icon-paixu"></i>{{time ? $t('common.SortByTime') : $t('common.SortByGroup')}}</button>
            <button class="redButton m_l_10"
                    @click="getAdd"><i class="icon iconfont icon-tianjia"></i>{{$t('common.AddGroup')}}</button>
          </dt>
        </dl>
      </div>
      <table class="allTable"
             cellspacing="0">
        <thead>
          <tr>
            <td class="w_3">{{$t('common.Group')}}</td>
            <td class="w_2">{{$t('common.Subgroup')}}</td>
            <td class="w_2">{{$t('common.Editable')}}</td>
            <td class="w_2">{{$t('common.Status')}}</td>
            <td class="w_2">{{$t('common.Action')}}</td>
          </tr>
        </thead>
        <tbody>
          <template v-if="bazaarList && bazaarList.length !== 0">
            <tr v-for="(item,index) in bazaarList"
                :key="index">
              <td class="w_3">{{item.CategoryName}}</td>
              <td class="w_2">{{item.SubCategoryName}}</td>
              <td class="w_2">{{item.Editable ? $t('common.Yes') : $t('common.No')}}</td>
              <td class="w_2">{{item.Status=='1'? $t('common.Show'):$t('common.Hide')}}</td>
              <td class="w_2"><i class="icon iconfont icon-bianji1"
                   style="color:#d41b47"
                   @click="getoperation(item.Id)"></i></td>
            </tr>
          </template>
          <tr v-else>
            <th colspan="5">{{$t('common.noData')}}</th>
          </tr>
        </tbody>
      </table>
      <!-- 分页 -->
      <page :totalPage='page'
            :page='offset'
            @on-getList="pageChange"
            v-if="bazaarList && bazaarList.length !==0"></page>
    </div>
    <!-- admin 类别设置 新增类别弹窗 -->
    <dialogArea :show="show"
                @cancel="cancel"
                @confirm="confirm"
                :title="$t('common.AddGroup')">
      <div slot="content">
        <div class="content">
          <!-- 大类 -->
          <div class="broad-heading">
            <span class="vome">*</span>
            <span class="heading">{{$t('common.Group')}}</span>
            <bazaarSelect :chooseData='nameList'
                          v-model="user"
                          :matchValue="'Name'"
                          :needReturn="'Id'"
                          :placeholder="$t('common.ChooseGroup')"
                          :showValue="'{{Name}}'"
                          @newsClass='newsClass'>
              <template #newsClassText>
                <span style="padding-bottom:5px;display: inline-block;padding-left: 5px;font-size: 13px;">{{$t('common.AddNewGroup')}}</span>
              </template>
            </bazaarSelect>
          </div>
          <div class="retail"
               v-show="newly">
            <input type="text"
                   class="input"
                   v-model="retail">
            <u @click="getascertain">{{$t('common.Ok')}}</u>
          </div>
          <!-- 子类 -->
          <div class="broad-heading">
            <span class="vome">*</span>
            <span class="heading">{{$t('common.Subgroup')}}</span>
            <bazaarSelect :chooseData='subclassList'
                          v-model="all"
                          :matchValue="'Name'"
                          :needReturn="'Id'"
                          :placeholder="$t('common.ChooseSubgroup')"
                          :showValue="'{{Name}}'"
                          @newsClass='newsClassName'>
              <template #newsClassText>
                <span style="padding-bottom:5px;display: inline-block;padding-left: 5px;font-size: 13px;">{{$t('common.AddNewSubgroup')}}</span>
              </template>
            </bazaarSelect>
          </div>
          <div class="retail"
               v-show="reg">
            <input type="text"
                   class="input"
                   v-model="region">
            <u @click="getensure">{{$t('common.Ok')}}</u>
          </div>
          <!-- 状态 -->
          <div class="state">
            <span class="vome">*</span>
            <span style="padding-right:20px">{{$t('common.Status')}}</span>
            <label>
              <input type="radio"
                     v-model="status"
                     value="true"
                     name="nice" @change="statusChange('add')"><span class="top">{{$t('common.Show')}}</span>
            </label>
            <label>
              <input type="radio"
                     name="nice"
                     v-model="status"
                     value="false"
                     @change="statusChange('add')"><span class="top">{{$t('common.Hide')}}</span>
            </label>
          </div>
          <!-- 可编辑 -->
          <div class="editor">
            <span class="vome">*</span>
            <span style="padding-right:20px">{{$t('common.Editable')}}</span>
            <label v-show="status==true||status=='true'">
              <input type="radio"
                     v-model="isEdit"
                     value="true"
                     name="ll"><span class="top">{{$t('common.Yes')}}</span>
            </label>
            <label v-show="status==true||status=='true'">
              <input type="radio"
                     name="ll"
                     value="false"
                     v-model="isEdit"><span class="top">{{$t('common.No')}}</span>
            </label>
            <span v-show="status==false||status=='false'" class="top">{{$t('common.No')}}</span>
          </div>
        </div>
      </div>
    </dialogArea>
    <!-- 修改弹出框 -->
    <dialogArea :show='edit'
                @cancel='compile'
                @confirm="operation"
                :title="$t('common.EditGroup')">
      <div slot="content">
        <div class="content">
          <!-- 大类 -->
          <div class="broad-heading">
            <span class="vome">*</span>
            <span class="heading">{{$t('common.Group')}}</span>
            <bazaarSelect :chooseData='nameList'
                          v-model="editData.Category"
                          :matchValue="'Name'"
                          :needReturn="'Id'"
                          :placeholder="$t('common.ChooseGroup')"
                          :showValue="'{{Name}}'"
                          @newsClass='newsClassName'
                          disabled="true">
              <template #newsClassText>
                <span style="padding-bottom:5px;display: inline-block;padding-left: 5px;">{{$t('common.AddNewGroup')}}</span>
              </template>
            </bazaarSelect>
          </div>
          <!-- 子类 -->
          <div class="broad-heading">
            <span class="vome">*</span>
            <span class="heading">{{$t('common.Subgroup')}}</span>
            <!-- <bazaarSelect :chooseData='subclassList'
                          v-model="editData.SubCategoryName"
                          :matchValue="'Name'"
                          :needReturn="'Id'"
                          :placeholder="$t('common.ChooseSubgroup')"
                          :showValue="'{{Name}}'"
                          @newsClass='newsClassName'
                          disabled="true">
              <template #newsClassText>
                <span style="padding-bottom:5px;display: inline-block;padding-left: 5px;">{{$t('common.AddNewSubgroup')}}</span>
              </template>
            </bazaarSelect> -->
            <div class="warp"> <i class="icon iconfont icon-sanjiaojiantou-xia multipleSelectArror"></i>{{editData.SubCategoryName}}</div>
          </div>
          <!-- 状态 -->
          <div class="state">
            <span class="vome">*</span>
            <span style="padding-right:20px">{{$t('common.Status')}}</span>
            <label>
              <input type="radio"
                     v-model="editData.Status"
                     value="true"
                     @change="statusChange('edit')"
                     name="nice"><span class="top">{{$t('common.Show')}}</span>
            </label>
            <label>
              <input type="radio"
                     name="nice"
                     v-model="editData.Status"
                     value="false"
                     @change="statusChange('edit')"
                     checked="checked"><span class="top">{{$t('common.Hide')}}</span>
            </label>
          </div>
          <!-- 可编辑 -->
          <div class="editor">
            <span class="vome">*</span>
            <span style="padding-right:20px">{{$t('common.Editable')}}</span>
            <label v-show="editData.Status==true||editData.Status=='true'">
              <input type="radio"
                     v-model="editData.Editable"
                     value="true" name="ll"><span class="top">{{$t('common.Yes')}}</span>
            </label>
            <label v-show="editData.Status==true||editData.Status=='true'">
              <input type="radio"
                     name="ll"
                     value="false" v-model="editData.Editable"><span class="top">{{$t('common.No')}}</span>
            </label>
            <span v-show="editData.Status==false||editData.Status=='false'" class="top">{{$t('common.No')}}</span>
          </div>
        </div>
      </div>
    </dialogArea>
  </div>
</template>

<script>
import bazaarSelect from '../../myComponents/bazaarSelect'
export default {
  components: { bazaarSelect },
  data () {
    return {
      bazaarList: [],
      nameList: [], // 获取大类
      subclassList: [], // 获取子类
      show: false,
      offset: 0,
      page: 0,
      user: '',
      all: '',
      flag: false,
      subclasShow: false,
      retail: '',
      newly: false,
      reg: false,
      region: '',
      isEdit: true,
      status: true,
      edit: false,
      editData: {
        Category: null,
        editable: true,
        Id: 0,
        Status: true,
        SubCategory: null
      },
      editId: null,
      time: false
    }
  },
  beforeCreate () {
    this.$parent.topName = this.$t('common.MarketingCategoryManagement')
  },
  created () {
    this.Grouplist()
    // 获取大类列表
    this.$axiox.get('/api/v1/admin/category/group/list').then(res => {
      this.nameList = res.data
    })
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    document.getElementById('index').addEventListener('click', closeMenu)
  },
  destroyed () {
    document.getElementById('index').removeEventListener('click', closeMenu)
  },
  methods: {
    statusChange (isAdd) {
      if (isAdd === 'add') {
        if (this.status === false || this.status === 'false') {
          this.isEdit = false
        }
      } else {
        if (this.editData.Status === false || this.editData.Status === 'false') {
          this.editData.Editable = false
        }
      }
    },
    getsubclassList (groupId) {
      // 获取子类列表
      this.$axiox.get(`/api/v1/admin/category/subgroup/list?groupId=${groupId}`).then(res => {
        this.subclassList = res.data
      })
    },
    Grouplist (pageIndex = 1, pageSize = 10, sort = 'time') {
      // 获取首屏数据
      this.$axiox.get(`/api/v1/admin/category/list?pageIndex=${pageIndex}&pageSize=${pageSize}&sort=${sort}`).then(res => {
        this.bazaarList = res.data.items
        this.offset = res.data.offset
        this.page = res.data.pages
      })
    },
    regimentation () {
      this.time = !this.time
      let sort = this.time ? 'group' : 'time'
      this.Grouplist(this.offset, 10, sort)
    },
    // 新增类别提交弹框显示
    getAdd () {
      this.show = true
    },
    // 新增类别取消弹框
    cancel (val) {
      this.show = val
      this.user = ''
      this.all = ''
    },
    // 新增类别确认按钮
    confirm (val) {
      if (this.user.length === 0) {
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.ChooseGroup'),
          stayTime: 5
        })
      } else if (this.all.length === 0) {
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.ChooseSubgroup'),
          stayTime: 5
        })
      }
      this.$axiox.post('/api/v1/admin/category', {
        category: this.user,
        subCategory: this.all,
        editable: this.isEdit,
        status: this.status
      }).then(res => {
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.AddSuccess'),
          stayTime: 5
        })
        this.user = ''
        this.all = ''
        this.Grouplist()
        this.show = false
      })
    },
    // 更新编辑回显
    getoperation (id) {
      this.editId = id
      this.edit = true
      this.editData = this.bazaarList.find(item => item.Id === id)
      // this.getsubclassList(id)
    },
    // 修改类别取消
    compile (val) {
      this.edit = val
    },
    // 修改类别确认
    operation () {
      this.$axiox.put('/api/v1/admin/category', {
        id: this.editId,
        category: this.editData.Category,
        subCategory: this.editData.SubCategory,
        editable: this.editData.Editable,
        status: this.editData.Status
      }).then(res => {
        this.edit = false
        this.Grouplist()
      })
    },
    // 分页
    pageChange (val) {
      let sort = this.time ? 'group' : 'time'
      this.Grouplist(val, 10, sort)
    },
    newsClass () {
      this.newly = !this.newly
      this.flag = !this.flag
    },
    newsClassName () {
      this.reg = !this.reg
      this.subclasShow = !this.subclasShow
    },
    // 点击确定添加大类
    getascertain () {
      const isRepetition = this.nameList.find(el => el.Name === this.retail)
      if (isRepetition) {
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.GroupExists'),
          stayTime: 5
        })
      }

      if (this.retail === '' || this.retail.trim() === '') {
        this.retail = ''
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.EnterGroupName'),
          stayTime: 5
        })
      } else {
        this.$axiox.post('/api/v1/admin/category/group', {
          id: 1,
          name: this.retail
        }).then(res => {
          this.user = res.data
          // 获取大类列表
          this.$axiox.get('/api/v1/admin/category/group/list').then(res => {
            this.nameList = res.data
            this.retail = ''
          })
        })
      }
      this.newly = !this.newly
    },
    // 添加子类列表
    getensure () {
      const isRepetition = this.subclassList.find(el => el.Name === this.region)
      if (isRepetition) {
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.SubgroupExists'),
          stayTime: 5
        })
      }
      if (this.region === '' || this.region.trim() === '') {
        this.region = ''
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.EnterSubgroupName'),
          stayTime: 5
        })
      } else {
        this.$axiox.post('/api/v1/admin/category/subgroup', {
          groupId: this.user,
          name: this.region
        }).then(res => {
          // 获取子类列表
          this.all = res.data
          this.getsubclassList(this.user)
          this.region = ''
        })
      }
      this.reg = !this.reg
    }
  },
  watch: {
    user: function (val) {
      this.getsubclassList(val)
    }
  }
}
function closeMenu () {}
</script>

<style>
.warp {
  position: relative;
  max-width: 180px;
  min-width: 180px;
  width: 100%;
  padding-left: 10px;
  height: 30px;
  line-height: 30px;
  border-radius: 30px;
  text-align: left;
  cursor: no-drop;
  z-index: 5;
  background-color: #f5f5f5;
}
.warp i {
  font-size: 13px;
  color: #c73343;
  float: right;
  line-height: 30px;
  padding-right: 10px;
}
#bazzer th {
  text-align: center;
  color: #8b8686;
  padding: 40px;
  font-size: 14px;
  font-weight: 400;
}
#bazzer input[type="radio"] {
  margin: 0 6px;
  -webkit-appearance: none;
  border: 1px solid #c50f3c;
  vertical-align: middle;
  width: 15px;
  height: 15px;
  /* float: left; */
  border-radius: 50%;
}
#bazzer input[type="radio"]:checked {
  background-image: url("../../../assets/img/checked.png");
  background-size: 100%;
  background-color: #c50f3c;
}
#bazzer .allTable thead td {
  border-bottom: 2px solid #d68497;
  padding: 12px 0px 10px 10px;
}
#bazzer .allTable tbody td {
  padding: 12px 0px 10px 10px;
}

#bazzer .allTable tbody tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

.broad-heading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
}
.broad-heading .heading {
  padding-right: 20px;
}
.broad-heading input {
  height: 25px;
  border: 1px solid #c50f3c;
  border-radius: 5px;
}
.retail {
  padding-left: 37%;
  padding-bottom: 10px;
}
.retail .input {
  width: 55%;
  height: 30px;
  border: 1px solid #c5103c;
  border-radius: 4px;
}
.retail u {
  position: absolute;
  line-height: 30px;
  right: 31%;
  color: #cf3e62;
  cursor: pointer;
}
.editor {
  padding-left: 34%;
  display: flex;
  padding-top: 20px;
}
.state {
  padding-left: 34%;
  display: flex;
}

.top {
  padding-right: 20px;
  /*line-height: 20px;*/
}
.vome {
  color: #c50f3c;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/bazaar/bazaar.vue